import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "border": "1px solid #ccc"
  }
};
import '@wangeditor/editor/dist/css/style.css';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { onBeforeUnmount, shallowRef, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
export default {
  name: 'Editor',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    editorConfig: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const editorRef = shallowRef();
    const toolbarConfig = {};

    const editorConfig = _objectSpread({
      placeholder: '请输入内容...',
      MENU_CONF: {
        uploadImage: {
          server: '/admin/information/config?action=uploadimage',

          onBeforeUpload(file) {
            ElMessage.error('上传图片最大不可超过2MB');
          },

          fieldName: 'your-fileName',
          base64LimitSize: 2 * 1024 * 1024 // 10M 以下插入 base64

        }
      }
    }, props.editorConfig);

    const mode = 'default';
    const valueHtml = computed({
      set(val) {
        emit('update:modelValue', val);
      },

      get() {
        return props.modelValue;
      }

    });
    watch(() => props.editorConfig.readOnly, newVal => {
      const editor = editorRef.value;

      if (!newVal) {
        editor.enable();
      } else {
        editor.disable();
      }
    }, {
      flush: 'sync'
    });
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });

    const handleCreated = editor => {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Toolbar), {
        style: {
          "border-bottom": "1px solid #ccc"
        },
        editor: _unref(editorRef),
        defaultConfig: toolbarConfig,
        mode: mode
      }, null, 8, ["editor"]), _createVNode(_unref(Editor), {
        style: {
          "height": "320px",
          "overflow-y": "hidden"
        },
        modelValue: _unref(valueHtml),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(valueHtml) ? valueHtml.value = $event : null),
        defaultConfig: editorConfig,
        mode: mode,
        onOnCreated: handleCreated
      }, null, 8, ["modelValue"])]);
    };
  }

};